import { useAutoneTranslation } from '@autone/translations';

import { NoDataSvg } from '../../icons';
import { cn } from '../../utils';

interface NoDataMessageProps {
  title?: string;
  subtitle?: string;
  className?: string;
  svgProps?: {
    height?: number | string;
    width?: number | string;
  };
}

export const NoDataMessage = ({
  title,
  subtitle,
  className,
  svgProps,
}: NoDataMessageProps) => {
  const { height: svgHeight, width: svgWidth } = svgProps || {};
  const { common } = useAutoneTranslation();

  return (
    <div
      className={cn(
        'w-full flex flex-col items-center justify-center p-10 rounded-sm bg-background',
        className,
      )}
    >
      <NoDataSvg height={svgHeight} width={svgWidth} />
      <h3 className="text-muted-foreground text-lg font-medium">
        {title ?? common('table-body.no-data.title')}
      </h3>

      <p className="text-center text-muted-foreground">
        {subtitle ?? common('table-body.no-data.subtitle')}
      </p>
    </div>
  );
};
